/**
 *  Initialize Menu
 */

var menu = (function() {
  var pub = {}; // public facing functions

  pub.init = function() {
    menuListeners();
    closeListeners();
	causeListeners();
  };

  function menuListeners() {
    var options = {
      onClose: function(modal) {
        $(modal).removeClass('is-open');
      },
      disableScroll: true,
      disableFocus: true,
      hasAnimation: true
    };

    var $targets = $('[data-menu-target]');
    var $triggers = $('[data-menu-trigger]');
    var $menuTriggers = $('.menu').find($triggers);
    var $submenuitems = $('.submenuitem');

    $triggers.click(function() {
      var target = $(this).data('menu-trigger');
      
      if( target == 'act'){
        window.location.href = '/get-involved';
      }else{
        // set active class on target element
        $targets
          .removeClass('active')
          .filter('[data-menu-target="' + target + '"]')
          .addClass('active');
  
        // set active class for nav items inside menu
        $menuTriggers
          .removeClass('active')
          .filter('[data-menu-trigger="' + target + '"]')
          .addClass('active');
  
        $('[data-cause-codename]').removeClass('active');
        MicroModal.show('menu', options);
      }
    });

    // Close the menu if sub menu item links to anchor on the same page
    $submenuitems.click(function () {
        if ($(this).attr('href').indexOf('#') >= 0) {
            MicroModal.close('menu');
        }
    });
    }

  function closeListeners() {
    // Using data-micromodal-close wasn't working because the event target isn't always correct
    $('[data-menu-close]').click(function() {
      $('[data-cause-codename]').removeClass('active');
      MicroModal.close('menu');
    });
  }

  function causeListeners() {
    var $causes = $('[data-cause-codename]');

    // Set up an event listener to handle browser resizing
    var mql = window.matchMedia('(min-width: 1280px)');
    mql.addListener(handleMediaChange);
    handleMediaChange(mql);

    // Add or remove event listeners based on whether the media query is a match
    function handleMediaChange(mediaQueryList) {
      if (mediaQueryList.matches) {
        $causes.find('.menu__link').on('mouseover', handleMouseover);
        $causes.find('.menu__icon').off('click', handleClick);
      } else {
        $causes.find('.menu__link').off('mouseover', handleMouseover);
        $causes.find('.menu__icon').on('click', handleClick);
      }
    }

    // Add active class to the cause and load data if it's not already there
    function handleMouseover() {
      var $cause = $(this).closest($causes);
      var $menuContent = $cause.find('.menu__content');

      $causes.removeClass('active');
      $cause.addClass('active');

      if ($menuContent.is(':empty')) {
        $.ajax({
          url: '/menu/cause/' + $cause.data('cause-codename'),
          type: 'GET',
          success: function(data) {
            $menuContent.html(data);
          }
        });
      }
    }

    // If clicked and already active, just remove that class
    function handleClick() {
      var $cause = $(this).closest($causes);

      if ($cause.hasClass('active')) {
        $cause.removeClass('active');
      } else {
        handleMouseover.call(this);
      }
    }
	}

  return pub;
})();
